import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "../components";
import { Renewal } from "@/api/williams/renewals";
import { useFormContext } from "react-hook-form";
import { useModalDialog } from "@/hooks";
import { useState } from "react";
import { Welder } from "@/api/williams/welders";
import { WelderCard } from "./components/WelderCard";
import { WelderRow } from "./components/WelderRow";
import { WelderSelectionDialog } from "../welders/dialogs";

export function RenewalFormWelders({ initialWelders = [] }: { initialWelders: Welder[] }) {
  const [welders, setWelders] = useState<Welder[]>(initialWelders);

  const dialog = useModalDialog();
  const form = useFormContext<Renewal>();
  const updates = form.watch("welders") ?? [];

  function handleSelectWelders() {
    dialog.show(WelderSelectionDialog, {
      initialWelders: welders.filter((welder) => updates.some((x) => x.welderId === welder.welderId)),
      onAccept: (selectedWelders) => {
        setWelders(selectedWelders);
        buildUpdateList(selectedWelders);
      },
    });
  }

  function buildUpdateList(welders: Welder[]) {
    const newUpdates = updates?.filter((x) => welders.some((w) => w.welderId === x.welderId)) ?? [];
    newUpdates.push(
      ...welders
        .filter((welder) => !newUpdates.some((x) => x.welderId === welder.welderId))
        .map((welder) => ({
          name: welder.name,
          welderId: welder.welderId,
          update: true,
          reinstatement: false,
        }))
    );

    form.setValue("welders", newUpdates, { shouldDirty: true });
  }

  return (
    <div className="mt-4 mb-4">
      <div className="d-flex justify-content-between">
        <h3>Welders</h3>
        <div className="d-flex gap-2 my-auto">
          <IconButton icon={faSearch} title="Search" onClick={handleSelectWelders} />
        </div>
      </div>

      {updates.length > 0 ? (
        <>
          <table className="table table-sm text-center d-none d-xl-table mt-2">
            <thead className="table-light">
              <tr>
                <th className="text-start">Welder</th>
                <th>CFR 192</th>
                <th>CFR 195</th>
                <th>Basic</th>
                <th>Basic + NDE</th>
                {/* <th>Renewal</th> */}
                {/* <th>Reinstatement</th> */}
              </tr>
            </thead>
            <tbody>
              {updates.map((update) => (
                <WelderRow key={update.welderId} welder={update} />
              ))}
            </tbody>
          </table>

          <div className="d-xl-none d-block mt-2">
            {updates.map((update) => (
              <WelderCard key={update.welderId} welder={update} />
            ))}
          </div>
        </>
      ) : (
        <p>Click the search button to add welders.</p>
      )}
    </div>
  );
}
